var map = {
	"./Page04.jpg": "./src/EGRContent/Story/AamaKoMaya/images/Page04.jpg",
	"./aama.gif": "./src/EGRContent/Story/AamaKoMaya/images/aama.gif",
	"./aama_ko_maya_heading.png": "./src/EGRContent/Story/AamaKoMaya/images/aama_ko_maya_heading.png",
	"./aama_ko_maya_heading.svg": "./src/EGRContent/Story/AamaKoMaya/images/aama_ko_maya_heading.svg",
	"./background_001.jpg": "./src/EGRContent/Story/AamaKoMaya/images/background_001.jpg",
	"./background_002.jpg": "./src/EGRContent/Story/AamaKoMaya/images/background_002.jpg",
	"./background_01.jpg": "./src/EGRContent/Story/AamaKoMaya/images/background_01.jpg",
	"./background_02.jpg": "./src/EGRContent/Story/AamaKoMaya/images/background_02.jpg",
	"./bg_Page01.jpg": "./src/EGRContent/Story/AamaKoMaya/images/bg_Page01.jpg",
	"./bg_Page02.jpg": "./src/EGRContent/Story/AamaKoMaya/images/bg_Page02.jpg",
	"./bg_Page03.jpg": "./src/EGRContent/Story/AamaKoMaya/images/bg_Page03.jpg",
	"./bg_Page04.jpg": "./src/EGRContent/Story/AamaKoMaya/images/bg_Page04.jpg",
	"./bg_Page05.jpg": "./src/EGRContent/Story/AamaKoMaya/images/bg_Page05.jpg",
	"./bg_Page06.jpg": "./src/EGRContent/Story/AamaKoMaya/images/bg_Page06.jpg",
	"./bg_Page07.jpg": "./src/EGRContent/Story/AamaKoMaya/images/bg_Page07.jpg",
	"./bg_Page08.jpg": "./src/EGRContent/Story/AamaKoMaya/images/bg_Page08.jpg",
	"./bg_Page09.jpg": "./src/EGRContent/Story/AamaKoMaya/images/bg_Page09.jpg",
	"./bg_Page10.jpg": "./src/EGRContent/Story/AamaKoMaya/images/bg_Page10.jpg",
	"./bg_Page13.jpg": "./src/EGRContent/Story/AamaKoMaya/images/bg_Page13.jpg",
	"./bg_cover01.png": "./src/EGRContent/Story/AamaKoMaya/images/bg_cover01.png",
	"./bg_cover_page.jpg": "./src/EGRContent/Story/AamaKoMaya/images/bg_cover_page.jpg",
	"./cover_pagenew.jpg": "./src/EGRContent/Story/AamaKoMaya/images/cover_pagenew.jpg",
	"./img_cover_page.png": "./src/EGRContent/Story/AamaKoMaya/images/img_cover_page.png",
	"./kid01.png": "./src/EGRContent/Story/AamaKoMaya/images/kid01.png",
	"./kid02.png": "./src/EGRContent/Story/AamaKoMaya/images/kid02.png",
	"./kid03.png": "./src/EGRContent/Story/AamaKoMaya/images/kid03.png",
	"./kids.png": "./src/EGRContent/Story/AamaKoMaya/images/kids.png",
	"./mum-kids.png": "./src/EGRContent/Story/AamaKoMaya/images/mum-kids.png",
	"./mum-kids01.png": "./src/EGRContent/Story/AamaKoMaya/images/mum-kids01.png",
	"./mum-kids02.png": "./src/EGRContent/Story/AamaKoMaya/images/mum-kids02.png",
	"./mum-kids03.png": "./src/EGRContent/Story/AamaKoMaya/images/mum-kids03.png",
	"./mum-kids04.png": "./src/EGRContent/Story/AamaKoMaya/images/mum-kids04.png",
	"./mum-kids05.png": "./src/EGRContent/Story/AamaKoMaya/images/mum-kids05.png",
	"./mum-kids06.png": "./src/EGRContent/Story/AamaKoMaya/images/mum-kids06.png",
	"./mum-kids07.png": "./src/EGRContent/Story/AamaKoMaya/images/mum-kids07.png",
	"./mum.png": "./src/EGRContent/Story/AamaKoMaya/images/mum.png",
	"./mum01.png": "./src/EGRContent/Story/AamaKoMaya/images/mum01.png",
	"./mum02.png": "./src/EGRContent/Story/AamaKoMaya/images/mum02.png",
	"./mum03.png": "./src/EGRContent/Story/AamaKoMaya/images/mum03.png",
	"./mum_standing.png": "./src/EGRContent/Story/AamaKoMaya/images/mum_standing.png",
	"./mum_umbrella.png": "./src/EGRContent/Story/AamaKoMaya/images/mum_umbrella.png",
	"./page03.jpg": "./src/EGRContent/Story/AamaKoMaya/images/page03.jpg",
	"./page10_mum_kids.png": "./src/EGRContent/Story/AamaKoMaya/images/page10_mum_kids.png",
	"./page12_mum_kids.png": "./src/EGRContent/Story/AamaKoMaya/images/page12_mum_kids.png",
	"./page15_mum_kids.png": "./src/EGRContent/Story/AamaKoMaya/images/page15_mum_kids.png",
	"./page3_mum_kids.png": "./src/EGRContent/Story/AamaKoMaya/images/page3_mum_kids.png",
	"./page6_mum_kids.png": "./src/EGRContent/Story/AamaKoMaya/images/page6_mum_kids.png",
	"./page9_mum_kids01.png": "./src/EGRContent/Story/AamaKoMaya/images/page9_mum_kids01.png",
	"./rain.gif": "./src/EGRContent/Story/AamaKoMaya/images/rain.gif",
	"./rain_new.gif": "./src/EGRContent/Story/AamaKoMaya/images/rain_new.gif",
	"./thumbnail.png": "./src/EGRContent/Story/AamaKoMaya/images/thumbnail.png",
	"./thunder_storm.gif": "./src/EGRContent/Story/AamaKoMaya/images/thunder_storm.gif",
	"./thunder_storm.png": "./src/EGRContent/Story/AamaKoMaya/images/thunder_storm.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/AamaKoMaya/images sync recursive ^\\.\\/.*$";